'use client'

import { useAppSelector } from 'features/hooks'
import { RootState } from 'features/store'
import { isUserAvailable } from 'helpers/authUser'
import SignUpCTA from '@/components/preview/SignUpCTA'

const IngredientSignUpCTA = () => {
  const user = useAppSelector((state: RootState) => state.culineerAuth.user)
  const isAuthenticated = isUserAvailable(user)

  if (isAuthenticated) return null

  return (
    <div className="mt-12">
      <SignUpCTA message="Join Culineer for free to find seasonal ingredients near you, discover local recipes, and connect with farmers in your area." />
    </div>
  )
}

export default IngredientSignUpCTA
